<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
        <section class="section-new">
            <div class="container">
                <el-row>
                    <el-col :span="24">
                        <div class="card card-lift shadow border-0 card-address_page mb-3">
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('menu.pro_about')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('submenu.gerbflag')}}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="section py-1 mb-3">
            <div class="container">
                <card shadow class="card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="text-center mt-2">
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span class="news_title">{{$t('gerbflag.gerbtitle')}}</span></div>
                        </div>
                        <div class="mt-3 py-3 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-11">
                                    <span class="news_title">{{$t('gerbflag.subtitle')}}</span>
                                    <p style="text-align: justify;">{{$t('gerbflag.subtitle_text')}}</p>
                                    <img src="img/logo/Pro_logo.png" class="news_image">
                                        <a href="img/logo/Pro_logo.png" class="card_gerb_link">
                                            <span class="card_info_link">{{$t('general.download')}}</span>
                                            <img src="img/strategy/png-file-format-symbol.svg" class="image_gerb_icon">
                                        </a>

                                    <p style="text-align: justify;" v-html="$t('gerbflag.subtitle_text1')"></p>
                                    <img src="img/logo/Pro_logo.png" class="news_image">
                                    <img src="img/ill/prokuratura_mini_line.png" class="news_image">
                                    <a href="img/logo/Pro_logo.cdr" class="card_gerb_link">
                                        <span class="card_info_link">{{$t('general.download')}}</span>
                                        <img src="img/strategy/cdr-file-format-symbol.svg" class="image_gerb_icon">
                                    </a>
                                    <a href="img/logo/Pro_logo_line.cdr" class="card_gerb_link" style="margin-top: 5px;">
                                        <span class="card_info_link">{{$t('general.download')}}</span>
                                        <img src="img/strategy/cdr-file-format-symbol.svg" class="image_gerb_icon">
                                    </a>
                                    <span class="news_title">{{$t('gerbflag.subtitle1')}}</span>
                                    <p style="text-align: justify;" v-html="$t('gerbflag.subtitle_text2')"></p>
                                    <img src="img/ill/version3_min.jpg" class="news_image">
                                    <a href="img/ill/version3_min.jpg" class="card_gerb_link">
                                        <span class="card_info_link">{{$t('general.download')}}</span>
                                        <img src="img/strategy/jpg-file-format-variant.svg" class="image_gerb_icon">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style>
</style>
